<template>
  <section class="blogs-articles-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-arrow-right"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
      </div>
      
      <div class="blogs-grid">
        <div class="blog-card" v-for="(blog, index) in content.blogs" :key="index">
          <div class="blog-image-container">
            <img :src="blog.image" :alt="blog.title" class="blog-image" />
            <span class="category-tag">{{ blog.category }}</span>
          </div>
          <div class="blog-content">
            <div class="blog-meta">
              <span>{{ blog.meta }}</span>
            </div>
            <h3>{{ blog.title }}</h3>
            <a href="#" class="read-more-link">{{ blog.readMoreText }} <i class="fas fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AIMLItsBlogsComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Blogs & Articles Section */
.blogs-articles-section {
  padding: 100px 0;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
}

.blogs-articles-section .section-header {
  text-align: center;
  margin-bottom: 80px;
}

.blogs-articles-section .section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(251, 14, 118, 0.1);
  border: 1px solid rgba(251, 14, 118, 0.3);
  padding: 8px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #FB0E76;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.blogs-articles-section .section-tag i {
  font-size: 12px;
  color: #FB0E76;
}

.blogs-articles-section .section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.blogs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.blog-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(246, 236, 79, 0.3);
}

.blog-image-container {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.blog-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.blog-card:hover .blog-image {
  transform: scale(1.1);
}

.category-tag {
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.blog-content {
  padding: 25px;
}

.blog-meta {
  margin-bottom: 15px;
}

.blog-meta span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.blog-content h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.4;
}

.read-more-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.8);
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.read-more-link:hover {
  background: rgba(0, 0, 0, 0.9);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  gap: 10px;
}

.read-more-link i {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.read-more-link:hover i {
  transform: translateX(2px);
}

/* Responsive Design */
@media only screen and (max-width: 1200px) {
  .blogs-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media only screen and (max-width: 991px) {
  .blogs-articles-section {
    padding: 80px 0;
  }
  
  .section-header h2 {
    font-size: 36px;
  }
}

@media only screen and (max-width: 767px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-tag {
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .blogs-grid {
    grid-template-columns: 1fr;
  }
  
  .blog-image-container {
    height: 180px;
  }
}
</style>
